import { render, staticRenderFns } from "./DecommissionChannel.vue?vue&type=template&id=18d0ef23&"
import script from "./DecommissionChannel.vue?vue&type=script&lang=js&"
export * from "./DecommissionChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports